export default "__VITE_ASSET__C0FY_PhJ__"